import { render, staticRenderFns } from "./TopContracts.vue?vue&type=template&id=37f278ae"
import script from "./TopContracts.vue?vue&type=script&lang=js"
export * from "./TopContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports